import { SubscribersList } from '@/components/subscribers';

export default function SubscribersPage() {
    return (
        <SubscribersList/>
    );
}